import { createInternalNeonAuth } from '@neondatabase/auth';
import { BetterAuthReactAdapter } from '@neondatabase/auth/react';

const neonAuthUrl = import.meta.env.VITE_NEON_AUTH_URL;

if (!neonAuthUrl) {
  console.error('[auth-client] VITE_NEON_AUTH_URL is not set. Authentication will not work.');
}

const _neonAuth = createInternalNeonAuth(neonAuthUrl, {
  adapter: BetterAuthReactAdapter(),
});

export const authClient = _neonAuth.adapter;

// Returns the JWT (set-auth-jwt from Neon Auth) for backend API authentication
export const getJWTToken = () => _neonAuth.getJWTToken();
